import React from 'react';
import PropTypes from 'prop-types';

import styles from '../../containers/checkoutPage/CheckoutPage.m.sass';

import {Field} from 'redux-form';

import {required} from '../../utils/validators';

import FieldSelect from '../fields/fieldSelect/FieldSelect';
import FieldText from '../fields/fieldText/FieldText';
import Switch from '../switch/Switch';

export default class ContactFields extends React.PureComponent {
  render() {
    return (
      <div className={styles.checkout_group}>
        <legend className={styles.checkout_legend}>Contact Information</legend>
        <div className={styles.checkout_fieldsRow}>
          <div className="col-lg-12  col-xl-6">
            <div className={styles.checkout_formTitle}>Skype login or Discord Tag #0000</div>
            <div className={styles.checkout_littleRow}>
              <div className="col-md-5">
                <Field
                  component={FieldSelect}
                  className={styles.checkout_fieldInline}
                  name="contact_method"
                >
                  <option value="skype">Skype</option>
                  <option value="discord">Discord</option>
                </Field>
              </div>
              <div className="col-md-7">
                <Field
                  component={FieldText}
                  className={styles.checkout_fieldInline}
                  type="text"
                  placeholder="Your skype login"
                  name="contact_value"
                  validate={required}
                />
              </div>
            </div>
          </div>

          <div className="col-lg-12  col-xl-6">
            <Field
              component={FieldText}
              className={styles.checkout_fieldInline}
              type="email"
              label="E-mail"
              placeholder="Your contact e-mail"
              name="email"
              validate={required}
            />
          </div>
        </div>

        {/* <div className={styles.checkout_helpLink}>
          <a href="#" className={styles.checkout_link}>How to find my skype login?</a>
        </div>

        <div className={styles.checkout_switch}>
          <Field
            component={Switch}
            label="Keep me updated on PrimeCarry.com services, hor offers and sales. If you dont’t love it, just unsubscribe. We make it easy."
            name="newsletter_subscribed"
          />
        </div> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/checkout/ContactFields.js